import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class TripService {

  constructor(
    private http: HttpClient
  ) { }

  getAllTrips(queryParam:any) {
    const params = new HttpParams({fromObject: queryParam});
    return this.http.get(urls.API_URL + urls.ASSIGN_TRIPS, {params})
      .pipe(catchError(errorHandl));
  }

  getTripById(id: any) {
    return this.http.get(urls.API_URL + urls.ASSIGN_TRIPS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  get(queryParams?: any): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.API_URL + urls.SERVICE_AREAS, { params })
      .pipe(
        catchError(errorHandl)
      );
  }

  sendtoMarketPlace(payload: any) {
    return this.http.post(urls.API_URL + urls.ASSIGN_COMPANY, payload)
      .pipe(catchError(errorHandl));
  }

  reserveTrip(tripId: string, isReserve: boolean) {
    return this.http
      .patch(`${urls.API_URL}${urls.RESERVE_TRIP}/${tripId}`,{isReserve})
      .pipe(catchError(errorHandl));
  }

  getTripEvents(queryParam: any) {
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get(urls.API_URL + urls.ASSIGN_EVENTS, { params })
      .pipe(catchError(errorHandl));
  }
   getPickerTripEvents(queryParam?: any) {
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get(urls.API_URL + urls.ASSIGN_EVENTS + urls.PICKER, { params })
      .pipe(catchError(errorHandl));
  }

    calculateMiles(queryParam:any){
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get('https://routing.nemtplatform.com/ors/v2/directions/driving-car', {params})
    .pipe(catchError(errorHandl));
  }

  assignToCompany(payload:any){
    return this.http.post(urls.API_URL + urls.ASSIGN_COMPANY ,payload)
    .pipe(catchError(errorHandl));
  }
  acceptMarketplaceTrip(payload:any){
    return this.http.post(urls.API_URL + urls.MARKETPLACE_TRIP ,payload)
    .pipe(catchError(errorHandl));
  }

  createTrip(payload: any, tripId: any) {
    if (tripId) {
      return this.http.patch(urls.API_URL + urls.ASSIGN_TRIPS + '/' + tripId, payload)
        .pipe(catchError(errorHandl));
    } else {
      return this.http.post(urls.API_URL + urls.ASSIGN_TRIPS, payload)
        .pipe(catchError(errorHandl));
    }

  }
  bulkVendorAdjust(payload: any) {
    return this.http.post(urls.API_URL + urls.ADJUST_TRIPS + '/bulk-adjustment', payload)
      .pipe(catchError(errorHandl));
  }
  bulkFundingSourceAdjust(payload: any) {
    return this.http.post(urls.API_URL + urls.ADJUST_BILLING_TRIPS + '/bulk-adjustment', payload)
      .pipe(catchError(errorHandl));
  }

   signatureUpdate(payload:any,tripId:any){
    return this.http.post(urls.API_URL + urls.ASSIGN_TRIPS +'/'+tripId +'/'+ urls.SIGNATURE_UPDATE ,payload)
      .pipe(catchError(errorHandl))
  }

    deleteBillingEvents(eventId: any) {
    return this.http.delete(urls.API_URL + urls.ASSIGN_EVENTS + `/${eventId}`)
      .pipe(catchError(errorHandl));
  }

  getTripsReport(params: any) {
    return this.http.get(urls.API_URL + urls.ASSIGN_TRIPS + '/report', { params })
      .pipe(catchError(errorHandl));
  }

}
